const NotificationSkeleton = () => {
  return (
    <div className="flex items-start gap-4 p-4 bg-white dark:bg-slate-800 rounded-xl border border-gray-200 dark:border-slate-700 animate-pulse">
      
      {/* Icon */}
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gray-200" />

      {/* Text */}
      <div className="flex-1 space-y-2">
        <div className="h-4 w-3/4 bg-gray-200 rounded" />
        <div className="h-3 w-32 bg-gray-200 rounded" />
      </div>
    </div>
  );
};

export default NotificationSkeleton;